import fetch from 'isomorphic-unfetch';

import { apiHeaders } from '../generic';

export default class JobsApis {
  static getJobDetails = async (id, req_data) => {
    const url = `${process.env.AE_API_URL}api/v1/jobs/${id}`;
    const headers = apiHeaders(req_data);
    const res = await fetch(url, {
      method: 'GET',
      headers
    });

    return res;
  };

  static searchJobs = async (payload) => {
    const reqBody = payload;
    const url = `${process.env.AE_API_URL}api/v1/jobs/search`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };

  static saveJob = async (id) => {
    const url = `${process.env.AE_API_URL}api/v1/saved_jobs/${id}/save`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify({})
    });

    return res;
  };

  static getSavedJobs = async (payload) => {
    const url = `${process.env.AE_API_URL}api/v1/saved_jobs/my_saved_jobs`;
    const reqBody = payload;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };

  static deleteSavedJob = async (id) => {
    const url = `${process.env.AE_API_URL}api/v1/saved_jobs/${id}`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'DELETE',
      headers
    });

    return res;
  };

  static myApplications = async (payload, req_data) => {
    const url = `${process.env.AE_API_URL}api/v1/applications/my_applications`;
    const reqBody = payload;
    const headers = apiHeaders(req_data);
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };

  static applyJob = async (id, payload) => {
    const reqBody = payload;
    const url = `${process.env.AE_API_URL}api/v1/applications/jobs/${id}/apply`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };
}
